import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function InputField({
    label,
    id,
    type = 'text',
    className,
    error,
    ...props
}) {
    return (
        <div className="group w-full relative">
            <div className="flex flex-col space-y-2">
                {label && (
                    <label
                        htmlFor={id}
                        className="uppercase text-[10px] tracking-widest text-gray-500 font-medium transition-colors group-focus-within:text-black"
                    >
                        {label}
                    </label>
                )}
                <input
                    id={id}
                    type={type}
                    className={twMerge(
                        "w-full bg-transparent border-b border-gray-300 py-2 text-sm font-light text-gray-900 outline-none transition-all duration-300",
                        "focus:border-black focus:border-b-[1.5px]",
                        "placeholder:text-gray-300",
                        error && "border-red-500 focus:border-red-500",
                        className
                    )}
                    {...props}
                />
            </div>
            {error && (
                <span className="absolute -bottom-5 left-0 text-[10px] text-red-500 tracking-wide">
                    {error}
                </span>
            )}
        </div>
    );
}
